<template>
    <div class="rangeFinance">
        <p> {{ label }} </p>
        <p> <span :class="{ euro: curency == '€'}">{{ curency }}</span> {{ value }} </p>
        <input
            type="range"
            :min="min"
            :max="max"
            :step="step"
            :name="name"
            :value="value"
            :id="id"
            @change="rangeFieldUpdate($event)">
    </div>
</template>
<script>
    export default {
        name: 'RangeFinance',
        props:{
            label: {type: String},
            curency: {type: String},
            min: {type: Number},
            max: {type: Number},
            step: {type: Number},
            name: {type: String},
            id: {type: String},
            value: {type: [Number, String]},
        },
        computed: {
            currValue: {
                get(){ return this.value},
                set(val){this.$emit('update:value', val) },
            },
        },
        methods:{
            rangeFieldUpdate(e){
                this.currValue = e.target.value;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .rangeFinance{
        margin-top: 2.5rem;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;

        p{
            flex-basis: 50%;
            place-self: flex-end;
            margin-bottom: 1.25rem;
            @include mixinTypography_new('font_16_18', $whiteCol, left);

            &:nth-child(2n){
                display: flex;
                justify-content: space-between;
                align-content: center;

                // text-align: right;
                border: 1px solid $secondaryCol;
                max-width: 160px;
                padding: .75rem 1rem .5rem;
                border-radius: 4px;
                line-height: 1.5rem;

                & > span:not(.euro){
                    color: $secondaryCol;
                    font-family: $medium;
                    @include mixinTypography_new('font_14_16', $secondaryCol, left, $medium);
                }

                .euro{ @include mixinTypography_new('font_18_24', $secondaryCol, left, $medium); }

                @include mixinTypography_new('font_18_24', $whiteCol);
            }
        }

        input{
            flex-basis:  100%;
        }

        [type=range] {
            -webkit-appearance: none;
            background: transparent;
            width: 100%;
        }
        [type=range]::-moz-focus-outer {
            border: 0;
        }
        [type=range]:focus {
            outline: 0;
        }
        [type=range]::-webkit-slider-runnable-track {
            background: #fbfbfc;
            cursor: default;
            height: .5rem;
            width: 100%;
            border-radius: 2rem;
        }
        [type=range]::-webkit-slider-thumb {
            box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2), 0 0 4px rgba(13, 13, 13, 0.2);
            background: $primaryCol;
            border: 4px solid $secondaryCol;
            border-radius: 2rem;
            box-sizing: border-box;
            height: 2rem;
            width: 2rem;
            -webkit-appearance: none;
            margin-top: -.75rem;
        }
        [type=range]::-moz-range-track {
            box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2), 0 0 1px rgba(13, 13, 13, 0.2);
            cursor: default;
            height: 8px;
            transition: all 0.2s ease;
            width: 100%;
            background: $whiteCol;
            border-radius: 2rem;
            height: .5rem;
        }
        [type=range]::-moz-range-thumb {
            box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2), 0 0 4px rgba(13, 13, 13, 0.2);
            background: $primaryCol;
            border: 4px solid $secondaryCol;
            border-radius: 2rem;
            box-sizing: border-box;
            cursor: default;
            height: 2rem;
            width: 2rem;
        }
        [type=range]::-ms-track {
            cursor: default;
            height: .5rem;
            width: 100%;
            background: $whiteCol;
            border-radius: 2rem;
        }
        [type=range]::-ms-thumb {
            box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2), 0 0 4px rgba(13, 13, 13, 0.2);
            width: 24px;
            margin-top: 2px;
            background: $primaryCol;
            border: 4px solid $secondaryCol;
            border-radius: 2rem;
            box-sizing: border-box;
            cursor: default;
            height: 2rem;
            width: 2rem;
        }

        [type=range]:disabled::-webkit-slider-thumb,
        [type=range]:disabled::-moz-range-thumb,
        [type=range]:disabled::-ms-thumb,
        [type=range]:disabled::-webkit-slider-runnable-track,
        [type=range]:disabled::-ms-fill-lower,
        [type=range]:disabled::-ms-fill-upper {
            cursor: not-allowed;
        }
    }
</style>
